import IEmpresa from './Empresa.interface';
import ITipoCuestionario from './TipoCuestionario.interface';
import ICuestionario from './cuestionario.interface';
import IEstado from './Estado.interface';
import IDenunciaArchivo from './denuncia-archivos.interface';
import IDenuncia from './Denuncia.interface';
import IUsuario from './Usuario.interface';
import ITipoUsuario from './TipoCuestionario.interface';
import ILogin from './login.interface';
import ILoginResponse from './LoginResponse';
import {INotification, TypeNotification} from './INotification.interface';
import {ETipoUsuario} from './TipoUsuario.enum';
import { ETipoCuestionario } from './TipoCuestionario.enum';
import IFiltroCuestionario from './FiltroCuestionario.interface';

export {
  IEmpresa,
  ITipoCuestionario,
  ICuestionario,
  IEstado,
  IDenuncia,
  IDenunciaArchivo,
  IUsuario,
  ILogin,
  ITipoUsuario,
  ILoginResponse,
  INotification,
  TypeNotification,
  ETipoUsuario,
  IFiltroCuestionario,
  ETipoCuestionario
};
